import { event_log } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { createResourceRequest } from '../api-crud.factory';

export type Cursor = string;

/**
 * POST /event-log — create a customer/person/client event.
 * Pure HTTP call: callers are responsible for assembling the full payload
 * (Origin, Medium, Resources, etc.).
 */
export const createEvent = createResourceRequest<
  Omit<event_log.Event, 'ID' | 'CreatedAt'>,
  event_log.Event
>('/event-log');

export function find({ url: { service: baseUrl }, token }: IAPI) {
  return async function findEvents(
    find: event_log.Find | Cursor
  ): Promise<event_log.FindEventsResponse> {
    const url = new URL(`/event-log`, baseUrl);
    if (typeof find === 'string') {
      url.searchParams.set('Cursor', find);
    } else {
      url.searchParams.set('Find', JSON.stringify(find));
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to fetch event log');
    }
  };
}
